import { apiUrl } from '../config/api'

export async function listWorkspaceClients(workspaceId, userId) {
  let params = {
    workspaceId: workspaceId,
    userId: userId
  }

  let url = apiUrl('ListClientsByWorkspaceAndUserIds')

  return sendReq(params, url)
}

export async function listClientsByUser(userId) {
  let params = {
    userId: userId,
    brandLabel: window.$brand
  }

  let url = apiUrl('ListClientsByUserId')

  return sendReq(params, url)
}

export async function listClientsWithSocietiesStatus(userId) {
  let params = {
    userId,
    brandLabel: window.$brand
  }

  let url = apiUrl('ListClientsWithSocietiesStatus')

  return sendReq(params, url)
}

export async function listClientsByParent(clientId) {
  let params = {
    parent: clientId,
    brandLabel: window.$brand
  }

  let url = apiUrl('ListClientsByParent')

  return sendReq(params, url)
}

export async function listAuthorizedClientsByClientUser(userId) {
  let params = {
    userId: userId
  }

  let url = apiUrl('ListAuthorizedClientsByUser')

  return sendReq(params, url)
}

export async function listClients(parent) {
  let params = {
    parent: parent,
    brandLabel: window.$brand
  }

  let url = apiUrl('ListClientsByParent')

  return sendReq(params, url)
}

export async function insertClient(params) {
  params.brandLabel = window.$brand

  let url = apiUrl('InsertClient')

  return sendReq(params, url)
}

export async function assignLawyerToClient(params) {
  let url = apiUrl('ToggleAssignClientLawyer')

  await fetch(url, { method: 'POST', body: JSON.stringify(params) })
}

export async function assignClientToWorkspace(params) {
  let url = apiUrl('AssignClientToWorkspace')

  await fetch(url, { method: 'POST', body: JSON.stringify(params) })
}

export async function getClientDataById(clientId) {
  let params = { clientId }

  let url = apiUrl('GetClientDataById')

  return sendReq(params, url)
}

export async function getMainClient(userId) {
  let params = { userId }

  let url = apiUrl('GetClientOrPersonByUser')

  return sendReq(params, url)
}

async function sendReq(params, url) {
  let res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params)
  }).catch((error) => console.log(error))
  return res.json()
}
